import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { useGetPreviewCustomizationSettingsUrl } from 'crm-links/layoutEditor/useGetPreviewCustomizationSettingsUrl';
import { PRODUCT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import CrmLogger from 'customer-data-tracking/loggers/CrmLogger';
import { usePermissionsContext } from '../../contexts/PermissionsContext';
import { jsx as _jsx } from "react/jsx-runtime";
function trackPreviewCustomization() {
  CrmLogger.log('recordInteractions', {
    action: 'choose link under record actions menu',
    subAction: undefined,
    objectType: PRODUCT_TYPE_ID
  });
}
export function ProductHighlightCustomizePreview() {
  const {
    hasScope
  } = usePermissionsContext();
  const isCrmPageEditorAdmin = hasScope('crm-page-editor-admin');
  const previewCustomizationSettingsUrl = useGetPreviewCustomizationSettingsUrl(PRODUCT_TYPE_ID);
  if (!isCrmPageEditorAdmin || !previewCustomizationSettingsUrl) {
    return null;
  }
  return /*#__PURE__*/_jsx(Button, {
    use: "link",
    target: "_blank",
    external: true,
    href: previewCustomizationSettingsUrl,
    onClick: trackPreviewCustomization,
    "data-test-id": "customize-preview-button",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "actions.customizePreview"
    })
  });
}